export default function(toBeHidden: boolean) {
  const postPropertyAnchors = document.querySelectorAll('.hi-navbar a[href="/kumita-brokers/post-property"]');
  postPropertyAnchors.forEach(anchor => {
    if (toBeHidden) {
      anchor.classList.add('hi-hidden');
    } else {
      anchor.classList.remove('hi-hidden');
    }
  });
}